import { ICompany } from "./company.interface";

export enum UserRole {
    SuperAdmin = 'Super Admin',
    LeadAdmin = 'Lead Admin',
    Admin = 'Admin',
    Owner = 'Owner',
    Outlet = 'Outlet',
    Uploader = 'Uploader',
    Reviewer = 'Reviewer'
}

export interface IUser {
    id: string;
    name: string;
    email: string;
    mobile: string;
    role: UserRole;
    company: ICompany;
    password?: string;
    isEmailVerified: boolean;
    isMobileVerified: boolean;
    isOnboarded: boolean,
    status: boolean;
    createdAt?: string;
    updatedAt?: string;
    buyerSummary?: boolean;
    reviewerSummary?: boolean;
    userAccessList?: string[];
    isSecondaryOwner?: boolean;
    secondaryOwnerRole?: string;
    isDemo?: boolean;
    isNarration?: boolean;
    thumbnail?: string;
    profileSetupCurrentPage: string;
    profileSetupCompanyPageSkip: boolean;
    freeTrialStartDateTime: string;
    isPaidUser?: boolean;
    freeTrialDays: number;
    invoiceCount?: number;
    enablePurchase?: boolean;
    isHyperpureEnabled?: boolean;
    parent?: string;
}